import logoNegative from '@/assets/brand/kuniri-logo-negativo.svg'
import logoPositive from '@/assets/brand/kuniri-logo.svg'
import symbolNegative from '@/assets/brand/kuniri-simbolo-negativo.svg'
import symbolPositive from '@/assets/brand/kuniri-simbolo.svg'
import { useTranslation } from 'react-i18next'

type LogoVariant = 'positive' | 'negative' | 'symbol' | 'symbol-negative'

interface KuniriLogoProps {
  variant?: LogoVariant
  height?: number
  className?: string
}

const SOURCES: Record<LogoVariant, string> = {
  positive: logoPositive,
  negative: logoNegative,
  symbol: symbolPositive,
  'symbol-negative': symbolNegative,
}

/**
 * Frozen brand artwork only. Never rebuild the wordmark with a font, recolour
 * petals or rotate the mark (docs/brand-kit/guidelines.md).
 */
export function KuniriLogo({
  variant = 'positive',
  height = 40,
  className,
}: KuniriLogoProps) {
  const { t } = useTranslation()
  return (
    <img
      src={SOURCES[variant]}
      height={height}
      alt={t('common.appName')}
      className={className}
      style={{ width: 'auto', height }}
      draggable={false}
    />
  )
}
